import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

import { ref, onBeforeMount, nextTick } from "vue" 
    import acMenuItem from "./acMenuItem.vue";
    
export default /*#__PURE__*/_defineComponent({
  __name: 'acContextMenu',
  props: {
        items: Array,
        displaysTriangle: Boolean
    },
  emits: ["menuDone"],
  setup(__props, { emit: __emit }) {

    const acMenu = ref(null)
    
    const emit = __emit

    const closeMenu = () => {
        emit("menuDone")
    }

    onBeforeMount(() =>  {
        nextTick(() =>{
            acMenu.value?.focus()
        })
    })


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("ul", {
    class: _normalizeClass([{'displays-triangle': __props.displaysTriangle}, "task-menu py-2 px-4 max-w-[25rem]"]),
    ref_key: "acMenu",
    ref: acMenu,
    tabindex: "0",
    onBlur: closeMenu
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.items, (item) => {
      return (_openBlock(), _createBlock(acMenuItem, {
        onActionPerformed: closeMenu,
        key: item.name,
        name: item.name,
        icon: item.icon,
        action: item.action
      }, null, 8, ["name", "icon", "action"]))
    }), 128))
  ], 34))
}
}

})